import gql from "graphql-tag";

export const GetOverviewReport = gql`
  query GetReports(
    $productId: String
    $date: QueryableDateTimeRange!
    $videoId: String
  ) {
    reports {
      overviewReport(productId: $productId, date: $date, videoId: $videoId) {
        averageViews
        pinkButtonClicks
        completedPurchases
        totalViews {
          id
          name
          totalViews {
            date
            viewCount
          }
        }
        totalSales {
          id
          name
          sales {
            date
            salesCount
          }
        }
        videoList {
          id
          name
          thumbnailUrl
          stats {
            totalViews
            totalEarnings
            totalSales
          }
        }
        productList {
          id
          name
          sku
          stats {
            totalVideosCreated
            totalVideoViews
            totalEarnings
          }
          images {
            id
            url
          }
        }
        originList {
          origin
          totalViews
        }
      }
    }
  }
`;

export const GetVideoReport = gql`
  query GetVideoReports($date: QueryableDateTimeRange!, $videoId: String!) {
    reports {
      videoReport(videoId: $videoId, date: $date) {
        id
        name

        totalViews {
          date
          viewCount
        }

        averageDurationOfViews {
          viewerCount
          duration
        }

        pinkButtonClicks {
          count
          duration
        }

        totalSales {
          date
          salesAmount
        }

        originList {
          totalViews
          origin
        }
      }
    }
  }
`;

export const GetProductReport = gql`
  query GetProductReports($date: QueryableDateTimeRange!, $productId: String!) {
    reports {
      productReport(productId: $productId, date: $date) {
        id
        name
        numberVideos
        numberViews
        numberSales
        salesAmount

        totalViews {
          date
          viewCount
        }

        pinkButtonClicks {
          count
          duration
        }

        totalSales {
          date
          salesAmount
        }

        totalSalesCount {
          date
          salesCount
        }

        originList {
          totalViews
          origin
        }
      }
    }
  }
`;
